import React, {useEffect, useState} from 'react'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './Item.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'
import { inject, observer } from 'mobx-react'
import { DataForm } from '../../../libs/react-mpk/components'
import { FormWrapper, TableWrapper } from '../../../libs/react-mpk/wrapper'
import { Button, Dialog, DialogHeader, DialogContent, DialogTitle } from 'react-md'                                         
import { inputTypes } from '../../../libs/react-mpk/config/constant'

var _baseId = "mod-table-item"

const ItemTable = ({
  className       = '',
  showCommandbar  = true,
  history,
  sipStore,
  navigationStore,
  authStore
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  const [uploadModal, setUploadModal] = useState(false)
  const [showDialog, setShowDialog] = useState({item: {}, show: false})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
    TableWrapper.reload(_baseId)
  }

  function _closeUploadModal() {
    setUploadModal(false)
  }

  return (
    <>
    <Dialog
      visible={showDialog.show}
      disableFocusOnMount={() => { }}
      onRequestClose={() => {
        setShowDialog({show: false})
      }}
      style={{
        width: 600
      }}
    >
      <DialogHeader>
        <DialogTitle>Approval</DialogTitle>
      </DialogHeader>
      <DialogContent style={{ paddingTop: 0, paddingBottom: 0 }}>
        <DataForm
          defaultData={showDialog.item}
          hintShowIcon={true}
          definitions={[
            {
              inputType: inputTypes.SELECT,
              label: 'Status',
              key: 'approvalStatus',
              width: '100%',
              options: [
                {value: 'APPROVED', label: 'APPROVED'},
                {value: 'DRAFT', label: 'DRAFT'}
              ]
            },
            {
              inputType: inputTypes.INPUT,
              label: 'Notes',
              key: "approvalNotes",
              type: "text",
              width: "100%"
            },
          ]}
          additionalAction={[
            {
              show: true,
              render: () => (
                <Button style={{ marginRight: 15 }} onClick={() => {
                  setShowDialog({show: false})
                }}>Tutup</Button>
              )
            }
          ]}
          onSubmit={async (values, callback) => {
            try {
              let res = await service.approval([values]);
              callback('Ganti Status Approval Berhasil', false);
              TableWrapper.reload(_baseId)
              setShowDialog({show: false})
            } catch (e) {
              callback('', false, false, false)
            }
          }}>
        </DataForm>
      </DialogContent>
    </Dialog>
    <TableWrapper
      baseId={_baseId}
      title={t.translate('modules.Item.title')}
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="createdDate"
      columns={[
        {
          label: 'Kode',
          searchable: true,
          key: 'kode',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.kode)
        },{
          label: 'Nama',
          searchable: true,
          key: 'nama',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.nama)
        },{
          label: 'Penjualan',
          searchable: true,
          key: 'isPenjualan',
          type: TableWrapper.dataTypes.BOOLEAN,
          render: item => (item.isPenjualan?"Ya":"Tidak")
        },{
          label: 'Pembelian',
          searchable: true,
          key: 'isPembelian',
          type: TableWrapper.dataTypes.BOOLEAN,
          render: item => (item.isPembelian?"Ya":"Tidak")
        }, {
          label: 'Keterangan',
          searchable: true,
          key: 'keterangan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.keterangan)
        }
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/barang-dan-jasa/baru'), authStore.user.roleMap?authStore.user.roleMap['Barang & Jasa'].Create:false),
        new TableWrapper.action('Import Barang/Jasa', 'mdi mdi-import', () => setUploadModal(true), true),
      ]}
      itemActions={[
        new TableWrapper.action('Approval', 'mdi mdi-check-circle', (item) => setShowDialog({ data: item, show: true }), true),
        new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/barang-dan-jasa/${item.id}`), authStore.user.roleMap?authStore.user.roleMap['Barang & Jasa'].Edit:false),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, authStore.user.roleMap?authStore.user.roleMap['Barang & Jasa'].Delete:false)
      ]}
      onFetchData={ async query => {
        if(!query) query = {}
        if(sipStore.companyId) {
          query['perusahaanId.equals'] = sipStore.companyId
        }
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    <DataForm
      baseId={"item-import"}
      asDialog={true}
      defaultData={{}}
      definitions={[{
        inputType: FormWrapper.inputTypes.FILE_INPUT,
        label: 'File',
        key: 'file',
        theme: 'filled',
        style: {width: 200}
      }]}
      visible={uploadModal}
      submitLabel='Import Data'
      onSubmit={async (d, callback)=> {
        var formData = new FormData()
        formData.set('file', d.file)
        var uploadRes = await service.http.post('/upload', formData)
        if(uploadRes.data) {
          var importRes = await service.http.post('/item-import', {
            nama: uploadRes.data.name,
            origin: uploadRes.data.origin,
            perusahaanId: sipStore.companyId,
            type: d.jenis,
            ext: 'xls'
          })
        }
        callback('Data sedang di import. Mohon pantau progress import di menu log import.', false)
      }}
      onRequestClose={_closeUploadModal} />
    </>
  )
}

export default inject('sipStore', 'navigationStore', "authStore")(observer(ItemTable))
